import { useEffect, useState } from 'react';
import Popupform from '../../Components/Popupform/Popupform';
import { NavLink, useParams, useLocation } from "react-router-dom";
import Boucherpopup from '../../Components/Popupform/Boucherpopup';
import axios from 'axios';
import config from '../../config/config';
import { FiCheckCircle, FiDollarSign, FiClock, FiBook, FiDownload, FiArrowRight, FiPlayCircle } from 'react-icons/fi';

const Streamdetailpage = () => {
    const location = useLocation();
    const { banner, subBanner, image } = location.state || {};
    const { id } = useParams();

    const [singleStream, setSingleStream] = useState({});
    const [navcourse, setNavcourse] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showBoucherPopup, setShowBoucherPopup] = useState(false);

    useEffect(() => {
        const fetchSingleStreamData = async () => {
            try {
                const response = await axios.get(`${config.API_BASE_URL}/api/admin/get_streamsbyId/${id}`);
                setSingleStream(response.data.getStreamsById || {});
            } catch (error) {
                console.error("Error fetching stream data:", error);
            }
        };
        fetchSingleStreamData();
    }, [id]);

    useEffect(() => {
        const fetchNavCourse = async () => {
            try {
                const response = await axios.get(`${config.API_BASE_URL}/api/admin/get_allNavCourse`);
                setNavcourse(response.data.allnavCourse || []);
            } catch (error) {
                console.error("Error fetching course data:", error);
            }
        };
        fetchNavCourse();
    }, []);

    const handleOpenPopup = (e) => {
        if (e) e.preventDefault();
        setShowPopup(true);
        document.body.style.overflow = "hidden";
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        document.body.style.overflow = "auto";
    };

    const handleOpenBoucherPopup = (e) => {
        if (e) e.preventDefault();
        setShowBoucherPopup(true);
    };

    const handleCloseBoucherPopup = () => {
        setShowBoucherPopup(false);
    };

    useEffect(() => {
        return () => { document.body.style.overflow = "auto"; };
    }, []);

    // Helper for fee table logic
    const allRounds = ["round1", "round2", "round3", "round4", "round5", "round6"];
    const availableRounds = allRounds.filter(round =>
        singleStream?.cutoffTable?.some(item => item?.[round] && item[round] !== "")
    );

    return (
        <div className="bg-gray-50 min-h-screen">
            {/* Dynamic Banner */}
            <div className="bg-brand-orange py-16 px-4 relative overflow-hidden text-center md:text-left">
                <div className="absolute inset-0 bg-black/10"></div>
                <div className="container mx-auto relative z-10 flex flex-col md:flex-row items-center gap-8">
                    {image && (
                        <div className="w-24 h-24 bg-white rounded-xl p-3 shadow-lg flex-shrink-0 flex items-center justify-center">
                            <img
                                src={`${config.API_BASE_URL}/${image}`}
                                alt="College Logo"
                                className="max-w-full max-h-full object-contain"
                            />
                        </div>
                    )}
                    <div className="flex-grow text-white">
                        <h1 className="text-3xl md:text-4xl font-bold mb-2">
                            {banner || singleStream?.streamsName || "Stream Details"}
                        </h1>
                        <p className="opacity-90 text-lg mb-2">
                            {subBanner || `Explore detailed information about ${singleStream?.streamsName || "this program"}`}
                        </p>
                    </div>
                    <div className="flex-shrink-0">
                        <button onClick={handleOpenPopup} className="bg-white text-brand-orange font-bold px-6 py-2 rounded-full shadow-lg hover:bg-orange-50 transition">
                            Apply Now
                        </button>
                    </div>
                </div>
            </div>

            <div className="container mx-auto px-4 py-12">
                <div className="flex flex-col lg:flex-row gap-8">

                    {/* LEFT COLUMN */}
                    <div className="lg:w-3/4">

                        {/* Stream Highlight Card */}
                        <div className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 mb-8">
                            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
                                <h2 className="text-2xl font-bold text-gray-800">{singleStream?.streamsName || "Stream Details"}</h2>
                                <div className="mt-4 md:mt-0 bg-green-50 text-green-700 px-4 py-2 rounded-lg font-bold flex items-center">
                                    <FiDollarSign className="mr-1" /> 1st Year: ₹{singleStream?.streamsFee}
                                </div>
                            </div>

                            <div className="flex flex-wrap gap-4 text-sm text-gray-600 mb-6 bg-gray-50 p-4 rounded-xl">
                                <span className="flex items-center"><FiCheckCircle className="mr-2 text-brand-orange" /> 4.2 Rating</span>
                                <span className="flex items-center"><FiClock className="mr-2 text-brand-orange" /> 4 Years</span>
                                <span className="flex items-center"><FiBook className="mr-2 text-brand-orange" /> Full Time</span>
                            </div>

                            <p className="text-gray-600 leading-relaxed mb-6">{singleStream?.para1}</p>

                            <hr className="border-gray-100 mb-6" />

                            <div className="flex flex-wrap gap-4">
                                <button onClick={handleOpenBoucherPopup} className="flex items-center text-gray-600 hover:text-brand-orange font-semibold transition">
                                    <FiDownload className="mr-2" /> Download Brochure
                                </button>
                                <button onClick={handleOpenPopup} className="flex items-center text-brand-orange font-bold hover:text-orange-700 transition">
                                    Apply For This Course <FiArrowRight className="ml-2" />
                                </button>
                            </div>
                        </div>

                        {/* Semester Fees Table */}
                        {singleStream?.table1 && singleStream.table1.length > 0 && (
                            <div className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 mb-8 overflow-hidden">
                                <h3 className="text-xl font-bold text-gray-800 mb-6">Semester Wise Fees</h3>
                                <div className="overflow-x-auto">
                                    <table className="w-full text-sm text-left text-gray-600">
                                        <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                                            <tr>
                                                <th className="px-6 py-3 rounded-l-lg">Year</th>
                                                <th className="px-6 py-3">Semester</th>
                                                <th className="px-6 py-3">Tuition Fees</th>
                                                <th className="px-6 py-3">Sem Fees</th>
                                                <th className="px-6 py-3 rounded-r-lg">Yearly</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {singleStream.table1.map((item, idx) => (
                                                [0, 1].map((i) => (
                                                    <tr key={`${item._id}-${i}`} className="bg-white border-b hover:bg-gray-50">
                                                        {i === 0 && (
                                                            <td rowSpan={2} className="px-6 py-4 font-medium text-gray-900 border-r">{item.year}</td>
                                                        )}
                                                        <td className="px-6 py-4">Sem {(parseInt(item.year.match(/\d+/)?.[0] || '1') - 1) * 2 + (i + 1)}</td>
                                                        <td className="px-6 py-4">₹{item.tutionFees[i]}</td>
                                                        <td className="px-6 py-4">₹{item.semWiseFees[i]}</td>
                                                        {i === 0 && (
                                                            <td rowSpan={2} className="px-6 py-4 font-bold text-brand-orange border-l">₹{item.yearlyFees}</td>
                                                        )}
                                                    </tr>
                                                ))
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* Course Description */}
                        <div className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 mb-8">
                            <h3 className="text-xl font-bold text-gray-800 mb-4">Course Description</h3>
                            <p className="text-gray-600 leading-relaxed">{singleStream?.para2}</p>
                        </div>

                        {/* Cutoff Table */}
                        {singleStream?.cutoffTable && singleStream.cutoffTable.length > 0 && (
                            <div className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 mb-8 overflow-hidden">
                                <h3 className="text-xl font-bold text-gray-800 mb-2">{singleStream?.cutoffHeading || "Cutoff"}</h3>
                                <p className="text-gray-500 mb-6">{singleStream?.cutoffPara}</p>
                                <div className="overflow-x-auto">
                                    <table className="w-full text-sm text-left text-gray-600">
                                        <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                                            <tr>
                                                <th className="px-6 py-3">Category</th>
                                                {availableRounds.map(round => <th key={round} className="px-6 py-3 uppercase">{round}</th>)}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {singleStream.cutoffTable.map((item, index) => (
                                                <tr key={index} className="bg-white border-b hover:bg-gray-50">
                                                    <th className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">{item?.catregory}</th>
                                                    {availableRounds.map(round => <td key={round} className="px-6 py-4">{item?.[round]}</td>)}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* More Info */}
                        <div className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 mb-8">
                            <h3 className="text-xl font-bold text-gray-800 mb-4">Eligibility & Details</h3>
                            <div className="space-y-4">
                                <div>
                                    <h4 className="font-bold text-gray-700">Criteria</h4>
                                    <p className="text-gray-600">{singleStream?.eligibilityCriteriaPara}</p>
                                </div>
                                <div className="bg-orange-50 p-4 rounded-xl">
                                    <h4 className="font-bold text-gray-700">Curriculum</h4>
                                    <p className="text-gray-600">{singleStream?.courseDetailsPara}</p>
                                </div>
                            </div>
                        </div>

                    </div>


                    {/* RIGHT COLUMN (Sidebar) */}
                    <div className="lg:w-1/4">

                        {/* Quick Apply */}
                        <div className="bg-white rounded-3xl p-6 shadow-md border border-gray-100 mb-6 text-center">
                            <h4 className="font-bold text-gray-800 mb-2">Admission 2024</h4>
                            <p className="text-sm text-gray-500 mb-4">Admissions open for {singleStream?.streamsName}</p>
                            <button onClick={handleOpenPopup} className="w-full bg-brand-orange text-white font-bold py-3 rounded-full hover:bg-orange-700 transition mb-3">
                                Apply Now
                            </button>
                            <button onClick={handleOpenBoucherPopup} className="w-full bg-gray-100 text-gray-700 font-bold py-3 rounded-full hover:bg-gray-200 transition">
                                Download Brochure
                            </button>
                        </div>

                        {/* Video Widget */}
                        <div className="rounded-3xl overflow-hidden shadow-md mb-6 relative group cursor-pointer">
                            <div className="aspect-video bg-gray-900 flex items-center justify-center">
                                <FiPlayCircle className="text-white w-16 h-16 opacity-80 group-hover:opacity-100 transition" />
                            </div>
                            {/* Embed replaced with placeholder for performance/security, or keep simplified iframe */}
                        </div>

                        {/* Top Courses List */}
                        <div className="bg-white rounded-3xl p-6 shadow-md border border-gray-100">
                            <h4 className="font-bold text-gray-800 mb-4 border-b pb-2">Top Courses</h4>
                            <div className="space-y-4">
                                {navcourse.slice(0, 5).map((course, index) => (
                                    <div key={index} className="group">
                                        <a href={`/Collegespage/${course._id}`} className="block font-bold text-gray-700 group-hover:text-brand-orange transition text-sm mb-1">
                                            {course.pageName}
                                        </a>
                                        <p className="text-xs text-gray-500">Popular Choice</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            {/* Popup Logic */}
            {showPopup && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
                    <div className="bg-white rounded-2xl shadow-2xl relative w-full max-w-md overflow-hidden max-h-[90vh] overflow-y-auto">
                        <button onClick={handleClosePopup} className="absolute top-4 right-4 text-gray-400 hover:text-gray-800 transition z-10 bg-white rounded-full p-1 border">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        <Popupform />
                    </div>
                </div>
            )}
            {showBoucherPopup && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
                    <div className="bg-white rounded-2xl shadow-2xl relative w-full max-w-md overflow-hidden max-h-[90vh] overflow-y-auto">
                        <button onClick={handleCloseBoucherPopup} className="absolute top-4 right-4 text-gray-400 hover:text-gray-800 transition z-10 bg-white rounded-full p-1 border">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        <Boucherpopup />
                    </div>
                </div>
            )}

        </div>
    );
}

export default Streamdetailpage;
